import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=3f15fd23&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Logo.vue?vue&type=style&index=1&id=3f15fd23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15fd23",
  null
  
)

export default component.exports